<template lang="html">
  <section class="video-mode">
    <h1 class="video-mode-title">{{freeInfo.title}}</h1>
    <div class="video-mode-main" @click="$emit('toPage')">
      <div class="video-mode-main-button">
        <img src="./img/play-button.png" alt="">
      </div>
      <div class="video-mode-main-bg">
        <img :src="freeInfo.itemImage" alt="">
      </div>
      <div class="video-mode-main-desc">
        {{freeInfo.itemTitle}}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VideoMode',
  props: {
    freeInfo: {
      type: Object,
      default: () => {
        return {
          title: '才博',
          itemImage: '',
          itemTitle: '才博'
        }
      }
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.video-mode {
  &-title {
    font-size: rem(36);
    color: #333333;
    margin-bottom: rem(40);
    font-weight: bolder;
  }
  &-main {
    position: relative;
    border-radius: rem(10);
    overflow: hidden;
    &-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      > img {
        width: rem(78);
      }
    }
    &-bg {
      width: 100%;
      > img {
        width: 100%;
        border-radius: rem(10);
      };
    }
    &-desc {
      position: absolute;
      padding: 0 rem(30);
      box-sizing: border-box;
      bottom: rem(4);
      border-radius: rem(10);
      left: 0;
      width: 100%;
      height: rem(80);
      line-height: rem(80);
      color: #fff;
      font-size: rem(29);
      font-weight: bold;
      background-color: rgba(#000000, .45);
    }
  }
}
</style>
